import { format, parseISO } from 'date-fns'

/**
 * Format last login date for display
 * @param lastSignInAt - ISO 8601 datetime string or null/undefined
 * @param formatPattern - date-fns format pattern (default: 'yyyy年M月d日 HH:mm')
 * @returns Formatted date string or '-' if null/undefined
 */
export const formatLastLogin = (
  lastSignInAt: string | null | undefined,
  formatPattern: string = 'yyyy年M月d日 HH:mm'
): string => {
  if (!lastSignInAt || lastSignInAt === '0001-01-01T00:00:00Z') {
    return '-'
  }

  try {
    const date = parseISO(lastSignInAt)
    if (isNaN(date.getTime())) {
      return '-'
    }
    return format(date, formatPattern)
  } catch {
    return '-'
  }
}
